/* eslint-disable no-console */
import React, { ErrorInfo, ReactNode } from 'react';
import { ErrorDisplay } from '@components/error/error.display';
import { PropsOnlyChildren } from '@domain/types/prop.types';
import { Icon } from '@material-ui/core';
import { RetryButton } from '@components/error/error.boundary.styles';

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error | null;
}

export default class ErrorBoundary extends React.Component<PropsOnlyChildren, ErrorBoundaryState> {
  constructor(props: PropsOnlyChildren) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
    // We could also log the error to a reporting service
    console.log(errorInfo);
    console.error(error);
  }

  retry = (): void => {
    this.setState({
      hasError: false,
      error: null,
    });
  };

  render(): ReactNode {
    const { hasError, error } = this.state;
    if (hasError)
      return (
        <>
          <ErrorDisplay error={error} />
          <RetryButton variant='contained' color='secondary' onClick={this.retry} endIcon={<Icon>replay</Icon>}>
            Retry
          </RetryButton>
        </>
      );

    // eslint-disable-next-line react/destructuring-assignment
    return this.props.children;
  }
}
